var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user (1) 1",
    clipPath: "url(#clip0_4872_41908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 4C9.10457 4 10 3.10457 10 2C10 0.89543 9.10457 0 8 0C6.89543 0 6 0.89543 6 2C6 3.10457 6.89543 4 8 4Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.996 9.436L10.542 5.9C10.491 5.387 10.063 5 9.54795 5H6.45295C5.93695 5 5.50895 5.387 5.45895 5.887L5.00395 9.437C4.98595 9.579 5.02995 9.723 5.12495 9.83C5.21995 9.938 5.35595 10 5.49995 10H6.05995L6.45695 13.1C6.50795 13.612 6.93695 14 7.45295 14H8.54795C9.06395 14 9.49195 13.612 9.54195 13.113L9.93995 10H10.5C10.644 10 10.78 9.938 10.875 9.83C10.971 9.723 11.015 9.579 10.996 9.436Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.792 11.2232L10.668 12.1872C12.774 12.4952 14 13.1132 14 13.5002C14 14.0292 11.722 15.0002 8 15.0002C4.278 15.0002 2 14.0292 2 13.5002C2 13.1132 3.226 12.4942 5.333 12.1872L5.209 11.2232C2.853 11.5492 1 12.3062 1 13.5002C1 15.1422 4.521 16.0002 8 16.0002C11.479 16.0002 15 15.1422 15 13.5002C15 12.3062 13.147 11.5492 10.792 11.2232Z",
    fill: "#979EA8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4872_41908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsnIcon);
export default __webpack_public_path__ + "static/media/ASNIcon.4eccebdc1d73d622b164ee9e813772ab.svg";
export { ForwardRef as ReactComponent };